import { render } from "./BaseImagesGallery.vue?vue&type=template&id=a31c47fa&ts=true"
import script from "./BaseImagesGallery.vue?vue&type=script&lang=ts"
export * from "./BaseImagesGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__